import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CustomError } from 'types';
import { getFeatureToggles } from 'services/config/getFeatureToggles';
import { closeModal, openModal } from './modalReducer';

export type UserFeatureToggleType = {
  PARTNER: UserFeatureToggleState;
  BUSINESS_RELATION: UserFeatureToggleState;
};

export type UserFeatureToggleState = {
  AddProducts: boolean;
  ClientPricingPortal: boolean;
  CreateMandateProposal: boolean;
  JBMobileInsightsAccess: boolean;
  SubscriptionManagement: boolean;
  VideoIdentification: boolean;
  ViewMandateProposal: boolean;
  BulkClosure: boolean;
  EamEfaDashboard: boolean;
};

export type UserFeatureToggleStateType = {
  features: UserFeatureToggleType;
  isLoading: boolean;
  error?: CustomError;
};

export const initialUserToggleStatus: UserFeatureToggleStateType = {
  features: {
    PARTNER: {
      AddProducts: false,
      ClientPricingPortal: false,
      CreateMandateProposal: false,
      JBMobileInsightsAccess: false,
      SubscriptionManagement: false,
      VideoIdentification: false,
      ViewMandateProposal: false,
      BulkClosure: false,
      EamEfaDashboard: false,
    },
    BUSINESS_RELATION: {
      AddProducts: false,
      ClientPricingPortal: false,
      CreateMandateProposal: false,
      JBMobileInsightsAccess: false,
      SubscriptionManagement: false,
      VideoIdentification: false,
      ViewMandateProposal: false,
      BulkClosure: false,
      EamEfaDashboard: false,
    },
  },
  isLoading: false,
};

const _getUserTogglesThunk = createAsyncThunk('USER/getFeatureToggles', async (_: unknown, thunkAPI) => {
  try {
    return await getFeatureToggles();
  } catch (error: unknown) {
    thunkAPI.dispatch(
      openModal({
        modalType: 'JBErrorModalWrapper',
        modalProps: {
          httpError: error,
          okHandler: () => {
            thunkAPI.dispatch(closeModal());
          },
          technicalInfo: {
            title: 'Error when getting feature toggles information',
            userErrorMessage: `An error occurred when getting feature toggles information. Please try again later.`,
          },
        },
      }),
    );
    return thunkAPI.rejectWithValue(error);
  }
});
// wee need to do it the hacky way because as of now CreateAsyncThunk can't have zero argument
export const getUserTogglesThunk = (_: unknown = {}) => _getUserTogglesThunk(_);

const userFeatureToggleSlice = createSlice({
  name: 'USER_TOGGLES',
  initialState: initialUserToggleStatus,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(_getUserTogglesThunk.pending, (state) => {
      return { ...state, isLoading: true };
    });
    builder.addCase(_getUserTogglesThunk.fulfilled, (state, action) => {
      return { ...state, features: { ...action.payload }, isLoading: false };
    });
    builder.addCase(_getUserTogglesThunk.rejected, (state, action) => {
      return {
        ...state,
        error: action.payload as CustomError,
        isLoading: false,
      };
    });
  },
});

export default userFeatureToggleSlice.reducer;
